const title = document.querySelector('.view-product-title a');
if(title) {
  if(title.textContent.trim() === 'Tribute Stone' || title.textContent.toLowerCase().trim() === 'tribute stone') {
    window.refreshThemeCart = function () {
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          if (!cart.items || cart.item_count === 0) return;
  
          document.dispatchEvent(
            new CustomEvent('cart:update', {
              detail: {
                resource: cart,
                data: { sections: {} }
              }
            })
          );
        });
        setTimeout(hideCustomProperties, 100);
    };
  
    document.addEventListener('DOMContentLoaded', () => {
      hideCustomProperties();
      updateCartPropertyLabels();
    });
  
    const cartPropertyObserver = new MutationObserver(() => {
      clearTimeout(window.hidePropertiesTimer);
      window.hidePropertiesTimer = setTimeout(hideCustomProperties, 100);
      updateCartPropertyLabels();
    });
  
    cartPropertyObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
}

// 
function hideCustomProperties() {
  const labelsToHide = [
    'Remembrance Options',
    'Remembrance Symbol Button',
    'Legacy Options',
    'Legacy Symbol Button',
    'Heritage Options',
    'Heritage Symbol Button',
    'Extra Options',
    'Remembrance Additional Option',
    'Legacy Additional Option',
    'Heritage Additional Option',
    'Disclaimer'
  ];

  document.querySelectorAll('.cart-items__property').forEach(property => {
    const dt = property.querySelector('dt');
    if (!dt) return;

    if (labelsToHide.some(label => dt.textContent.includes(label))) {
      property.style.display = 'none';
    }

    const span = property.querySelector('span');
    if (!span) return;

    if (labelsToHide.some(label => span.textContent.includes(label))) {
      property.style.display = 'none';
    }
  });
}

if (window.location.pathname === '/cart' ) {
  document.addEventListener('DOMContentLoaded', hideCustomProperties);
}

// 
function updateCartPropertyLabels() {
  const labelChanges = {
    'Remembrance Line 1': '',
    'Remembrance Line 2': '',
    'Remembrance Symbol Library 1': '',
    'Remembrance Symbol Library 2': '',
    'Remembrance Hebrew Phrase 1': '',
    'Remembrance Hebrew Phrase 2': '',
    'Heritage Line 1': '',
    'Heritage Line 2': '',
    'Heritage Line 3': '',
    'Heritage Line 4': '',
    'Heritage Symbol Library 1': '',
    'Heritage Symbol Library 2': '',
    'Heritage Symbol Library 3': '',
    'Heritage Symbol Library 4': '',
    'Heritage Hebrew Phrase 1': '',
    'Heritage Hebrew Phrase 2': '',
    'Heritage Hebrew Phrase 3': '',
    'Heritage Hebrew Phrase 4': '',
    'Legacy Line 1': '',
    'Legacy Line 2': '',
    'Legacy Line 3': '',
    'Legacy Line 4': '',
    'Legacy Line 5': '',
    'Legacy Line 6': '',
    'Legacy Symbol Library 1': '',
    'Legacy Symbol Library 2': '',
    'Legacy Symbol Library 3': '',
    'Legacy Symbol Library 4': '',
    'Legacy Symbol Library 5': '',
    'Legacy Symbol Library 6': '',
    'Legacy Hebrew Phrase 1': '',
    'Legacy Hebrew Phrase 2': '',
    'Legacy Hebrew Phrase 3': '',
    'Legacy Hebrew Phrase 4': '',
    'Legacy Hebrew Phrase 5': '',
    'Legacy Hebrew Phrase 6': ''
  };

  document.querySelectorAll('.cart-items__property dt').forEach(dt => {
    let text = dt.textContent.trim();

    Object.keys(labelChanges).forEach(oldText => {
      if (text.includes(oldText)) {
        dt.textContent = labelChanges[oldText];
      }
    });
  });
}